import groq from 'groq';

export const ourClientsQuery = groq`
  *[_type == "ourClients"][0] {
    _id,
    title,
    description,
    backgroundImage {
      _id,
      asset->{
        _id,
        url
      },
      alt
    },
    clients[] {
      _id,
      name,
      logo {
        _id,
        asset->{
          _id,
          url
        },
        alt
      },
      position
    },
    professionalNames[] {
      _id,
      name,
      position,
      company
    },
    testimonialText
  }
`;
